module.exports = "<div class='form-group col-xs-3' >\r\n    <input type='submit' [value]='value' class='btn btn-success' (click)='submit()' [disabled]='!isFormValid'/>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/easyForms/components/submit/submit-input.component.html
// module id = ../../../../../app/shared/components/easyForms/components/submit/submit-input.component.html
// module chunks = main